module.exports = __webpack_public_path__ + "static/img-12-5b65256affbb4d9cbd262abd08d88dbe.jpeg";